import { render, staticRenderFns } from "./OrdersOverview.vue?vue&type=template&id=ed2e3522&"
import script from "./OrdersOverview.vue?vue&type=script&lang=js&"
export * from "./OrdersOverview.vue?vue&type=script&lang=js&"
import style0 from "./OrdersOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports